import { render, staticRenderFns } from "./SearchTagResult.vue?vue&type=template&id=4e7c368f&scoped=true&"
import script from "./SearchTagResult.vue?vue&type=script&lang=js&"
export * from "./SearchTagResult.vue?vue&type=script&lang=js&"
import style0 from "./SearchTagResult.vue?vue&type=style&index=0&id=4e7c368f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7c368f",
  null
  
)

export default component.exports